<template>
    <div class="bg-white py-10 sm:py-10" style="background-image: url('/images/home/features-cloud.png');" :style="{
        backgroundPosition: 'top center',
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
    }">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="mx-auto max-w-2xl lg:text-center">
                <h2 class="text-base/7 font-semibold text-emerald-600">{{ t('headings.why-us') }}</h2>
                <p
                    class="mt-2 text-pretty text-2xl font-semibold tracking-tight text-gray-900 sm:text-3xl lg:text-balance">
                    {{ t('headings.best-arabic-learning-experience') }}
                </p>
                <!-- <p class="mt-6 text-lg/8 text-gray-600">
                    Join us and experience an enriching journey through our online Quran, Arabic, and Islamic studies programs. Our Native Arabic tutors proficient in English.
                    <br /> <br />
                </p> -->
            </div>
            <div class="mx-auto mt-8 max-w-2xl sm:mt-16 lg:mt-20 lg:max-w-4xl">
                <dl class="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-3 lg:gap-y-16">
                    <div v-for="feature in features" :key="feature.name" class="relative">
                        <dt class="text-base/7 font-semibold text-gray-900 text-center">
                            <div class="flex items-center justify-center rounded-lg">
                                <img v-if="feature.icon" :src="feature.icon" alt="" class="size-10 text-primary" />
                                <!-- <component :is="feature.icon" class="size-16 text-primary" aria-hidden="true" /> -->
                            </div>
                            <div class="mt-8">
                                <span>
                                    {{ t(`headings.${feature.nameKey}`) }}
                                </span>
                            </div>
                        </dt>
                        <dd class="mt-2 text-base/7 text-gray-600 text-center">{{ t(`headings.${feature.descriptionKey}`) }}</dd>
                    </div>
                </dl>
            </div>
        </div>
    </div>
</template>

<script setup>
import {
    ChatBubbleLeftEllipsisIcon,
    CalendarIcon,
    CursorArrowRaysIcon,
    CubeIcon,
    GlobeAltIcon,
    ArrowPathIcon, CloudArrowUpIcon, FingerPrintIcon, LockClosedIcon } from '@heroicons/vue/24/outline'
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const features = [
    {
        nameKey: 'native-arabic-tutors',
        descriptionKey: 'native-arabic-tutors-description',
        icon: 'images/home/icon2.svg',
    },
    {
        nameKey: 'flexible-scheduling',
        descriptionKey: 'flexible-scheduling-description',
        icon: 'images/home/icon4.svg',
    },
    {
        nameKey: 'interactive-learning',
        descriptionKey: 'interactive-learning-description',
        icon: 'images/home/icon11.svg',
    },
    {
        nameKey: 'certified-tutors',
        descriptionKey: 'certified-tutors-description',
        icon: 'images/home/icon3.svg',
    },
    {
        nameKey: 'comprehensive-curriculum',
        descriptionKey: 'comprehensive-curriculum-description',
        icon: 'images/home/icon5.svg',
    },
    {
        nameKey: '24-7-support',
        descriptionKey: '24-7-support-description',
        icon: 'images/home/icon7.svg',
    },
]
</script>
